import { useState, useEffect } from "react";
import Button from "src/components/Button";
import DialogComponent from "../../../components/DialogComponent";
import { useAppSelector } from "src/hooks/redux";
import { selectItem } from "src/modules/spItems/selectors";
import { FlexCol, FlexRow } from "src/utils/flexLayouts";
import EmployeeReportSingle from "./EmployeeReportSingle";
import {
  myDocumentsListName,
  versionsByDocumentListName,
} from "src/api/config";
import _ from "lodash";

type Props = {
  open: boolean;
  toggleDialog: (b: boolean) => void;
  setOpen: (b: boolean) => void;
  versionView: any;
  setQuery: any;
  query: any;
  card: any
};

function ReportDocumentModal(props: Props) {
  const { open, toggleDialog, setOpen, versionView, setQuery, query, card } = props;

  return (
    <DialogComponent open={open} toggleDialog={toggleDialog}>
      <FlexCol className="max-w-[1053px]">
        <FlexCol>
          <div
            className="max-w-[70%] text-7.5 leading-[38px] font-bold text-black mb-8 break-words mr-5"
            dangerouslySetInnerHTML={{
              __html:
                (card && card.Title.replaceAll(" ", "&nbsp;")) ||
                "",
            }}
          />
        </FlexCol>
        <EmployeeReportSingle
          versionView={versionView}
          setQuery={setQuery}
          query={query}
          card={card}
        />
      </FlexCol>
    </DialogComponent>
  );
}

export default ReportDocumentModal;
